export const contentGenerationConfigFileCacheKey = (version, path) => `${version}::${path}`;

const CONFIG_VERSION_STATUSES = {
  ACTIVE: true,
  DRAFT: true,
  INACTIVE: true,
  UNSPECIFIED: true,
};

export const contentGenerationConfigVersionNumber = (value) => {
  const numberValue = Number(value || 0);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

export const normalizeContentGenerationConfigVersionStatus = (status = '') => {
  const rawStatus = String(status || '').trim();
  if (!rawStatus) return 'ACTIVE';

  const normalized = rawStatus
    .replace('CONTENT_GENERATION_CONFIG_VERSION_STATUS_', '')
    .replace('CONTENT_CONFIG_VERSION_STATUS_', '')
    .replace('CONTENT_CONFIG_STATUS_', '');
  return Object.prototype.hasOwnProperty.call(CONFIG_VERSION_STATUSES, normalized)
    ? normalized
    : 'UNSPECIFIED';
};

export const findPendingContentGenerationConfigVersion = (
  versionRows = [],
  pendingVersionSelection = null,
) => {
  if (!pendingVersionSelection) return null;
  return versionRows.find((row) => {
    if (normalizeContentGenerationConfigVersionStatus(row.status) !== pendingVersionSelection.status) {
      return false;
    }

    const rowVersion = contentGenerationConfigVersionNumber(row.version);
    if (pendingVersionSelection.targetVersion) {
      return rowVersion === contentGenerationConfigVersionNumber(pendingVersionSelection.targetVersion);
    }
    return rowVersion > contentGenerationConfigVersionNumber(pendingVersionSelection.newerThanVersion);
  });
};

export const getConfigFileName = (path = '') => {
  const parts = String(path).split('/').filter(Boolean);
  return parts[parts.length - 1] || path;
};

export const formatConfigFileSize = (sizeBytes) => {
  const size = Number(sizeBytes || 0);
  if (!Number.isFinite(size) || size <= 0) return '0 B';
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(size < 10 * 1024 ? 1 : 0)} KB`;
  return `${(size / (1024 * 1024)).toFixed(size < 10 * 1024 * 1024 ? 1 : 0)} MB`;
};

export const isJsonConfigFile = (contentType = '', path = '') => (
  String(contentType).toLowerCase().includes('json')
  || String(path).toLowerCase().endsWith('.json')
);

export const validateConfigFileContent = ({
  content = '',
  contentType = '',
  path = '',
}) => {
  if (!isJsonConfigFile(contentType, path)) {
    return { isValid: true, error: '' };
  }

  if (!String(content).trim()) {
    return { isValid: false, error: 'JSON content cannot be empty.' };
  }

  try {
    JSON.parse(content);
    return { isValid: true, error: '' };
  } catch (error) {
    return { isValid: false, error: error.message || 'Invalid JSON content.' };
  }
};

export const hasConfigFileChanged = (base = '', next = '') => String(base) !== String(next);
